var _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPlusCircled = function SvgPlusCircled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "M12.5.32C5.95.32.62 5.65.62 12.2S5.95 24.08 12.5 24.08s11.88-5.33 11.88-11.88S19.05.32 12.5.32m0 22.44c-5.822 0-10.56-4.737-10.56-10.56S6.678 1.64 12.5 1.64c5.823 0 10.56 4.737 10.56 10.56S18.323 22.76 12.5 22.76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "M16.46 11.54h-3.3v-3.3a.66.66 0 1 0-1.32 0v3.3h-3.3a.66.66 0 1 0 0 1.32h3.3v3.3a.66.66 0 1 0 1.32 0v-3.3h3.3a.66.66 0 1 0 0-1.32"
  })));
};
export default SvgPlusCircled;